/**
 * The container's hours as a bracket over the score lane — "its hours ·
 * 08:00–15:00 🇩🇰 · 🇦🇺 17:00–00:00" — the only hours the optimizer may add
 * drops to. Two brackets when they cross midnight. The axis is the
 * country's; the label reads Danish first like every other time.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { useCountryClock } from '@/features/drop-generator/components/shared/time/country-clock-context';
import { windowText } from '@/features/drop-generator/utils/clock/dk-label';

interface Props {
  startMin: number | null;
  /** The container's end, else its last regular drop. */
  endMin: number | null;
}

const pct = (hour: number) => (hour / 24) * 100;

export const SpanBracket: FC<Props> = ({ startMin, endMin }) => {
  const clock = useCountryClock();
  if (startMin === null || endMin === null) return <div className="h-6" />;
  const first = Math.floor(startMin / 60) % 24;
  const last = Math.floor(Math.min(endMin, 2879) / 60) % 24;
  const parts = last >= first ? [[first, last]] : [[first, 23], [0, last]];
  return (
    <div className="relative h-6">
      {parts.map(([a, b], i) => (
        <span
          key={a}
          className="absolute bottom-0 flex h-full flex-col justify-end transition-[left,width] duration-500 ease-out motion-reduce:transition-none"
          style={{ left: `${pct(a)}%`, width: `${pct(b - a + 1)}%` }}
        >
          {i === 0 ? (
            <span className="absolute bottom-2 left-1/2 -translate-x-1/2 whitespace-nowrap text-[10.5px] font-semibold text-primary">
              its hours · {windowText(startMin % 1440, endMin % 1440, clock)}
            </span>
          ) : null}
          <span className="h-1.5 rounded-t border-x border-t border-primary/60" />
        </span>
      ))}
    </div>
  );
};
